import { JSX } from "react";
import { ROW_TYPE, WaterfallRow } from "./waterfallRows";

type NameCellProps = {
  row: WaterfallRow;
};

export const NameCell = ({ row }: NameCellProps): JSX.Element => (
  <span className="t-flex t-flex-col t-min-w-0">
    <span
      className={row.type === ROW_TYPE.TOTAL ? "t-font-bold" : "t-font-normal"}
    >
      {row.label}
    </span>
    {row.type === ROW_TYPE.PARTY && (
      <span className="t-text-body-xs t-text-text-30 t-truncate">
        {row.sublabel}
      </span>
    )}
  </span>
);
